module.exports = __webpack_public_path__ + "static/media/social_media_youtube.085a4e0a.svg";